import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const setVisibilityEBoxLocations = (
  state: CarsState,
  action: PayloadAction<CarsState['eBoxLocations']['show']>
) => {
  state.eBoxLocations.show = action.payload;

  if (!action.payload) {
    state.selectedEBoxLocation = undefined;
  }
}
